var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.844,
    height: 34.588,
    viewBox: "0 0 34.844 34.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "survey_icon",
    transform: "translate(-151.055 -152.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M156.337,163.507a5.236,5.236,0,0,0,3.374-1.247h13.2a4.035,4.035,0,1,0,0-8.069h-13.2a5.257,5.257,0,0,0-8.656,4,5.338,5.338,0,0,0,5.282,5.318Zm19.33-5.318a2.747,2.747,0,0,1-2.751,2.751H160.848a5.135,5.135,0,0,0,.807-2.751,5.042,5.042,0,0,0-.807-2.751h12.067a2.771,2.771,0,0,1,2.751,2.751Zm-19.33-4a4,4,0,1,1-4,4A4.008,4.008,0,0,1,156.337,154.19Z",
    transform: "translate(0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M181.865,309.055H159.711a5.282,5.282,0,1,0,0,8.069h22.154a4.035,4.035,0,1,0,0-8.069Zm-29.526,4.035a4,4,0,1,1,4,4A4.007,4.007,0,0,1,152.339,313.09Zm29.526,2.751H160.848a5.135,5.135,0,0,0,.807-2.751,5.042,5.042,0,0,0-.807-2.751h21.017a2.751,2.751,0,1,1,0,5.5Z",
    transform: "translate(0 -142.871)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M192.315,353.588l-1.614,1.834-.77-.77a.648.648,0,0,0-.917.917l1.284,1.284a.676.676,0,0,0,.44.183h.037a.645.645,0,0,0,.477-.22l2.054-2.347a.647.647,0,0,0-.073-.917.64.64,0,0,0-.917.037Z",
    transform: "translate(-34.841 -184.91)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M176.106,463.915h-16.4a5.257,5.257,0,0,0-8.656,4.035,5.338,5.338,0,0,0,5.282,5.318,5.236,5.236,0,0,0,3.374-1.247h16.4a4.053,4.053,0,0,0,0-8.106Zm-23.768,4.071a4,4,0,1,1,4,4A4.007,4.007,0,0,1,152.339,467.986Zm23.768,2.751H160.848a5.134,5.134,0,0,0,.807-2.751,5.042,5.042,0,0,0-.807-2.751h15.295a2.747,2.747,0,0,1,2.751,2.751,2.779,2.779,0,0,1-2.788,2.751Z",
    transform: "translate(0 -285.737)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M197.336,505.835a.642.642,0,0,0-.917,0l-.88.88-.88-.88a.648.648,0,0,0-.917.917l.88.88-.88.88a.642.642,0,0,0,0,.917.62.62,0,0,0,.88,0l.88-.88.88.88a.62.62,0,0,0,.88,0,.642.642,0,0,0,0-.917l-.88-.88.88-.88a.592.592,0,0,0,.073-.917Z",
    transform: "translate(-39.203 -325.384)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M193.353,198.756a.62.62,0,0,0,.88,0l.88-.88.88.88a.62.62,0,0,0,.88,0,.642.642,0,0,0,0-.917l-.88-.88.88-.88a.648.648,0,0,0-.917-.917l-.88.88-.88-.88a.648.648,0,0,0-.917.917l.88.88-.88.88a.724.724,0,0,0,.073.917Z",
    transform: "translate(-38.777 -38.771)",
    fill: "#404040"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIcon);
export default __webpack_public_path__ + "static/media/survey_icon.a5786a57a03d25393bc71a866dfbb3d6.svg";
export { ForwardRef as ReactComponent };